'use client';

import { c as _c } from "react/compiler-runtime";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@repo/ui/components';
import { cn } from '@repo/ui/lib';
import { BookIcon, ChevronDownIcon } from 'lucide-react';
export const AISources = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("not-prose text-primary mb-4 text-xs", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Collapsible className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const AISourcesTrigger = t0 => {
  const $ = _c(10);
  let children;
  let count;
  let props;
  if ($[0] !== t0) {
    const {
      children: t1,
      className,
      count: t2,
      ...t3
    } = t0;
    children = t1;
    count = t2;
    props = t3;
    $[0] = t0;
    $[1] = children;
    $[2] = count;
    $[3] = props;
  } else {
    children = $[1];
    count = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== children || $[5] !== count) {
    t1 = children ?? <><p className="font-medium">Used {count} sources</p><ChevronDownIcon className="h-4 w-4" /></>;
    $[4] = children;
    $[5] = count;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <CollapsibleTrigger className="flex items-center gap-2" {...props}>{t1}</CollapsibleTrigger>;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export const AISourcesContent = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("mt-3 flex flex-col gap-2", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CollapsibleContent className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const AISource = t0 => {
  const $ = _c(12);
  let children;
  let href;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      children,
      href,
      title,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = props;
    $[4] = title;
  } else {
    children = $[1];
    href = $[2];
    props = $[3];
    title = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== title) {
    t1 = children ?? <><BookIcon className="h-4 w-4" /><span className="block font-medium">{title}</span></>;
    $[5] = children;
    $[6] = title;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== href || $[9] !== props || $[10] !== t1) {
    t2 = <a className="flex items-center gap-2" href={href} rel="noreferrer" target="_blank" {...props}>{t1}</a>;
    $[8] = href;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};